import {
    useMutation,
    UseMutationResult, useQueryClient,
} from '@tanstack/react-query'
import {
    useCallback,
} from 'react'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import simpleApi from 'app/services/simpleApi'
import requests from 'app/requests/Quote/Quote.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

type RequestParams = {
    quoteId: number,
    fileId: string,
}

const useRemoveQuotePdf = (
    onSuccess: () => void,
): UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const queryClient = useQueryClient()

    const refreshGetQuoteDocuments = useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: [RequestKeys.getQuoteDocuments],
        })
        onSuccess()
    }, [
        queryClient,
        onSuccess,
    ])

    const {
        onSuccess: onSuccessRemoveInvoice,
        onError,
    } = useHandleStatusRequest({
        id: 'QuotePdf',
        title: 'Document has been removed',
        onSuccess: refreshGetQuoteDocuments,
    })

    return useMutation({
        mutationFn: ({
            quoteId,
            fileId,
        }: RequestParams) => {
            return simpleApi({
                ...requests.removeQuotePdf({
                    quoteId,
                    fileId,
                }),
                token,
            })
        },
        onSuccess: onSuccessRemoveInvoice,
        onError,
    })
}

export default useRemoveQuotePdf
